module.exports = __webpack_public_path__ + "img/icon-stage-blue-t.a81ffcc5.png";